import React from 'react';
import {Link} from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-red-600">404</h1>
        <p className="text-2xl font-semibold text-gray-800 mt-4">Page not found</p>
        <p className="text-gray-500 mt-2">The page you're looking for doesn't exist or has been moved.</p>
        <div className="mt-8 flex justify-center gap-4">
          <Link to="/" className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700">Home</Link>
          <Link to="/apps" className="bg-gray-200 text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-300">Apps</Link>
        </div>
      </div>
    </div>
  );
}
